import { useEffect, useState } from "react";
import "./HeroRotator.css";

const INTERVAL_MS = 6000;

export function HeroRotator({ copy }) {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const slides = copy?.slides || [];

  useEffect(() => {
    if (paused) {
      return undefined;
    }
    if (typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return undefined;
    }
    if (!slides.length) {
      return undefined;
    }
    const id = window.setInterval(() => {
      setIndex((i) => (i + 1) % slides.length);
    }, INTERVAL_MS);
    return () => window.clearInterval(id);
  }, [paused, slides.length]);

  if (!slides.length) {
    return null;
  }

  return (
    <div
      className="hero-rotator"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      role="region"
      aria-roledescription="carousel"
      aria-label={copy.regionLabel}
    >
      <div className="hero-rotator-viewport">
        {slides.map((slide, i) => (
          <article
            key={slide.key}
            className={`hero-rotator-slide hero-rotator-slide--${slide.variant} ${
              i === index ? "is-active" : ""
            }`}
            aria-hidden={i !== index}
          >
            <span className="hero-rotator-label">{slide.label}</span>
            <h2 className="hero-rotator-title">{slide.title}</h2>
            <p className="hero-rotator-body">{slide.body}</p>
          </article>
        ))}
      </div>
      <div className="hero-rotator-dots" role="group" aria-label={copy.dotsLabel}>
        {slides.map((slide, i) => (
          <button
            key={slide.key}
            type="button"
            className={`hero-rotator-dot ${i === index ? "is-active" : ""}`}
            aria-label={copy.slideLabel(i + 1, slide.label)}
            aria-current={i === index ? "true" : undefined}
            onClick={() => setIndex(i)}
          />
        ))}
      </div>
    </div>
  );
}
